import letterNotification from './letter-notification'
import activityNotification from './activity-notification'
import letterCompose from './letter-compose'
import activityCompose from './activity-compose'
export default {
	items: [letterCompose, activityCompose, letterNotification, activityNotification]
} 
